// Get the API and client URLs from environment variables or use defaults
const API_URL = process.env.REACT_APP_API_URL || 'https://api.astro-vino.co.uk';
const CLIENT_URL = process.env.REACT_APP_LOCAL_URL || 'https://www.astro-vino.co.uk';

// Get the runtime config or use defaults
const config = {
  API_URL,
  CLIENT_URL,
  IMAGE_BASE_URL: API_URL,
  TINYMCE_API_KEY: process.env.REACT_APP_TINYMCE_API_KEY,
  endpoints: {
    settings: `${API_URL}/api/settings`,
    news: `${API_URL}/api/news`,
    gallery: `${API_URL}/api/gallery`,
    auth: `${API_URL}/api/auth`,
    upload: `${API_URL}/api/upload`,
    videos: `${API_URL}/api/videos`,
    credentials: `${API_URL}/api/settings/credentials`,
    contact: `${API_URL}/api/contact`,
    nightChart: `${API_URL}/api/night-chart`,
    skyNews: `${API_URL}/api/sky-news`,
    equipment: `${API_URL}/api/equipment`
  }
};

// Merge with window.CONFIG if it exists
if (typeof window !== 'undefined' && window.CONFIG) {
  Object.assign(config, window.CONFIG);
}

export { config };
